/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Zoom_Hint_DescInputs */

const en_ui_filter_zoom_hint_desc = /** @type {(inputs: Ui_Filter_Zoom_Hint_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag across a few days`)
};

const de_ui_filter_zoom_hint_desc = /** @type {(inputs: Ui_Filter_Zoom_Hint_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieh über ein paar Tage`)
};

/**
* | output |
* | --- |
* | "Drag across a few days" |
*
* @param {Ui_Filter_Zoom_Hint_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_zoom_hint_desc = /** @type {((inputs?: Ui_Filter_Zoom_Hint_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Zoom_Hint_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_zoom_hint_desc(inputs)
	return de_ui_filter_zoom_hint_desc(inputs)
});